import styled, { css } from 'styled-components';
import { Stack } from 'src/components';

export const Root = styled.div(
  ({ theme }) => css`
    align-items: center;
    background-color: ${theme.co.neutral99};
    color: ${theme.co.neutral20};
    display: flex;
    font-size: ${theme.sz.s3};
    min-height: 100dvh;
    min-width: 100vw;
    width: 100%;
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    width: 100%;
    padding: ${theme.sz.s24} ${theme.sz.s4} ${theme.sz.s4};

    @media (max-width: ${theme.sz.md}) {
      padding: ${theme.sz.s12} ${theme.sz.s1} ${theme.sz.s4};
    }
  `,
);

export const Header = styled.p(
  ({ theme }) => css`
    color: ${theme.co.secondary20};
    text-align: center;
    margin: 0 0 ${theme.sz.s4} 0;
    ${theme.typography.heading.desktop.m};
  `,
);

export const SummaryTitle = styled.p(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
  `,
);

export const SummaryDescription = styled.p(
  ({ theme }) => css`
    margin-top: ${theme.sz.s0};
    ${theme.typography.paragraph.m};
  `,
);

export const ContentWrapper = styled(Stack)(
  ({ theme }) => css`
    margin-top: ${theme.sz.s0};
  `,
);

export const ListWrapper = styled.div(
  ({ theme }) => css`
    min-width: ${theme.sz.ms};
    margin-top: ${theme.sz.s10};

    ul {
      overflow-y: inherit;
    }

    @media (max-width: ${theme.sz.md}) {
      width: 100%;
      min-width: unset;
      margin-top: ${theme.sz.s2};
    }
  `,
);

export const ButtonContainer = styled.div(
  ({ theme }) => css`
    margin: ${theme.sz.s4} 0;
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s4};

    @media (max-width: ${theme.sz.md}) {
      margin: 0;
    }
  `,
);

export const SettingsIconWrapper = styled.button(
  ({ theme }) => css`
    position: fixed;
    bottom: ${theme.sz.s12};
    left: ${theme.sz.s12};
    padding: 0;
    font-size: ${theme.sz.s10};
    height: ${theme.sz.s12};
    width: ${theme.sz.s12};
    cursor: pointer;
    display: flex;
    align-items: end;
    justify-content: space-around;
    border-radius: ${theme.bo.round};
    border: ${theme.bo.thinWidth} solid ${theme.co.neutral98};
    background: ${theme.co.neutral99};
    color: ${theme.co.secondary0};
    box-shadow: 0 3.84px 0 ${theme.co.neutral95};

    &:hover {
      background: ${theme.co.neutral98};
      color: ${theme.co.secondary60};
    }

    &:active {
      background: ${theme.co.neutral95};
      color: ${theme.co.secondary50};
    }

    @media (max-width: ${theme.sz.ml}) {
      display: none;
    }
  `,
);

export const AnimationContainer = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s68};
  `,
);
